/* 2.0 product pages — right-size the lower-section images.

   Why: those sections ship 1100-1600px images into a 375pt phone. The bytes
   are fine (Shopify negotiates WebP), but the DECODED bitmaps are not: ~53MB
   below the buy box alone. iOS Safari caps the decoded image memory a tab may
   hold and stops painting once it is hit, which is why the lower sections come
   up blank on iPhone.

   Passes:
   1. Parse time — every Shopify CDN <img src> and <source srcset> is capped at
      viewport width x2 as the browser reads it, before any fetch starts. On
      desktop that cap is 1600, the current maximum, so desktop is untouched.
      On a phone it is 750.
   2. On src/srcset change — the theme's lazy-loader writes the full-size URL
      in later; it gets re-capped each time.
   3. After layout — images still not downloaded are trimmed further, to about
      2x the space they actually occupy.

   It never upscales, never touches an image that already downloaded, and never
   touches an <img> that carries its own srcset (the theme sizes those). */
(function () {
  'use strict';
  var PAGES = [
    'breathefree-2-0-resistance-necklace',
    'breathefree-2-0-resistance-necklace-early-black-friday'
  ];
  var ok = false;
  for (var i = 0; i < PAGES.length; i++) if (location.pathname.indexOf(PAGES[i]) > -1) ok = true;
  if (!ok) return;

  var DPR = Math.min(window.devicePixelRatio || 1, 2);   /* 2x is as sharp as anyone can see */
  var STEP = 50, MIN = 200, MAX = 1600;

  function round(w) { return Math.max(MIN, Math.min(MAX, Math.ceil(w / STEP) * STEP)); }

  /* widest any image on this page can usefully be */
  var CAP = round(Math.max(320, window.innerWidth || 1024) * DPR);

  function param(url) {
    var m = url.match(/[?&]width=(\d+)/);
    return m ? parseInt(m[1], 10) : 0;
  }

  /* returns the capped url, or null when nothing needs changing */
  function capUrl(url, want) {
    if (!url || url.indexOf('/cdn/shop') === -1) return null;
    var have = param(url);
    if (have) { if (want >= have) return null; return url.replace(/([?&])width=\d+/, '$1width=' + want); }
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + want;
  }

  function applyImg(im, want) {
    if (im.getAttribute('srcset')) return;      /* the theme sizes this one itself */
    var next = capUrl(im.getAttribute('src') || '', want);
    if (!next) return;
    im.setAttribute('decoding', 'async');
    im.setAttribute('src', next);               /* width is now <= want, so this cannot re-trigger */
    im.setAttribute('data-bf-sized', String(want));
  }

  /* <picture><source srcset="a 1x, b 2x"> — cap every candidate */
  function applySource(el, want) {
    var ss = el.getAttribute('srcset');
    if (!ss) return;
    var changed = false;
    var out = ss.split(',').map(function (part) {
      var t = part.trim();
      if (!t) return t;
      var sp = t.split(/\s+/);
      var next = capUrl(sp[0], want);
      if (!next) return t;
      changed = true;
      sp[0] = next;
      return sp.join(' ');
    }).join(', ');
    if (!changed) return;
    el.setAttribute('srcset', out);
    el.setAttribute('data-bf-sized', String(want));
  }

  function capNode(node, want) {
    if (!node || node.nodeType !== 1) return;
    if (node.tagName === 'IMG') { applyImg(node, want); return; }
    if (node.tagName === 'SOURCE') { applySource(node, want); return; }
    if (node.querySelectorAll) {
      var a = node.querySelectorAll('img');
      for (var i = 0; i < a.length; i++) applyImg(a[i], want);
      var b = node.querySelectorAll('source[srcset]');
      for (var j = 0; j < b.length; j++) applySource(b[j], want);
    }
  }

  capNode(document.documentElement, CAP);

  new MutationObserver(function (recs) {
    for (var a = 0; a < recs.length; a++) {
      var rec = recs[a];
      if (rec.type === 'attributes') { try { capNode(rec.target, CAP); } catch (e) {} continue; }
      var added = rec.addedNodes;
      for (var b = 0; b < added.length; b++) { try { capNode(added[b], CAP); } catch (e) {} }
    }
  }).observe(document.documentElement, {
    childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset']
  });

  /* ---- after layout: trim what has not been fetched yet ---- */
  function trim() {
    var imgs = document.images;
    for (var i = 0; i < imgs.length; i++) {
      var im = imgs[i];
      try {
        if (im.complete && im.naturalWidth > 0) continue;   /* already downloaded */
        var r = im.getBoundingClientRect();
        if (r.width < 40) continue;                          /* hidden, or an icon */
        if (r.top < window.innerHeight * 1.5) continue;      /* near the viewport, leave the first paint alone */
        var want = round(r.width * DPR);
        applyImg(im, want);
        var pic = im.parentElement;
        if (pic && pic.tagName === 'PICTURE') {
          var s = pic.querySelectorAll('source[srcset]');
          for (var k = 0; k < s.length; k++) applySource(s[k], want);
        }
      } catch (e) {}
    }
  }

  function start() {
    trim();
    setTimeout(trim, 900);
    setTimeout(trim, 2600);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();